enum ChartMode {
  NONE = 'none', // no action will be show, even if you defined them and are passing them to the component
  COMPACT = 'compact', // actions will be available, but only in a dropdown triggered by a "..." button
  VERBOSE = 'verbose', // actions will be available, those with isHighlighted set to true will be show outside of the "..." button
}

export default ChartMode;
